module.exports = __webpack_public_path__ + "img/guy-avatar@3x.c6030370.png";